import React from 'react';
import CreateContent from "./create-content.jsx";
import UpdateContent from "./update-content.jsx";
import DeleteContent from "./delete-content.jsx";
import {navigateHook} from "../../../../../hooks/use-navigate.js";

const AuditContent = ({element}) => {
    const navigate = navigateHook();

    return (
        <table className="table report-table mb-4 audit-content-table">
            <thead style={{background: "#F2F2F2"}}>
                <tr className='text-left'>
                    <th style={{width: "15%"}}>ID</th>
                    <th style={{width: "15%"}}>Ação</th>
                    <th style={{width: "25%"}}>Agente</th>
                    <th style={{width: "55%"}}>Data/hora</th>
                </tr>
            </thead>

            <tbody>
                <tr className='text-left'>
                    <td>{ !element.deleted ? <a onClick={() => navigate(`/despacho/schedule-garrison/form/${element?.entityid}`, true)} rel="noreferrer" className={'report-link'}>{element?.entityid}</a> : <span className={'cursor-not-allowed'} title={'A atividade não é mais acessível após exclusão.'}>{element?.entityid}</span> }</td>
                    <td>{element?.action}</td>
                    <td>{element?.owner}</td>
                    <td>{element?.date_time}</td>
                </tr>

                { element?.action === "Cadastro" && (
                    <CreateContent element={element}/>
                )}

                { element?.action === "Alteração" && (
                    <UpdateContent element={element}/>
                )}

                { element?.action === "Exclusão" && (
                    <DeleteContent element={element}/>
                )}
            </tbody>
        </table>
    );
};

export default AuditContent;